/**
 * 让整个 .gf-filter-selection 都可以点击触发排序下拉（而不仅仅是 .sort-by-toggle）
 */
(function () {
  'use strict';

  if (typeof document === 'undefined') return;

  function initGfSortToggle(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll('.gf-filter-selection');
    if (!containers.length) return;

    containers.forEach(function (container) {
      if (container.dataset.mtGfSortBound === 'true') return;
      container.dataset.mtGfSortBound = 'true';

      var sortToggle = container.querySelector('.sort-by-toggle');
      if (!sortToggle) return;

      container.style.cursor = container.style.cursor || 'pointer';

      container.addEventListener('click', function (e) {
        if (sortToggle.contains(e.target)) {
          return;
        }
        e.preventDefault();
        sortToggle.click();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initGfSortToggle(document);
    });
  } else {
    initGfSortToggle(document);
  }

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            initGfSortToggle(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();

